/* Verosoul motion, TEST THEME ONLY.
   One IntersectionObserver. Each element revealed once, then unobserved.
   No scroll listener exists, so there is no per-frame cost.
*/
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  /* `.vs > * > *` is deliberately generic. Every Verosoul section wraps its
     content one level inside `.vs`, but the class of that wrapper differs:
     most pages use `.vs__inner`, the Resource Library uses `.rl-card`. This
     one rule covers both and will cover any future section without needing
     to be patched again.
     `.vscb__inner > *` adds the consult banners, which sit outside the .vs
     system entirely and would otherwise stay static. */
  var SELECTORS = ['.vs > * > *', '.vscb__inner > *', '.vs-cards > .vs-card', '.vs-videogrid > *'].join(',');

  /* Left alone on purpose:
       .vs-carousel__card  horizontally scrolled, transforms fight it
       .vs-tabs__panel     already fades on tab change
       .vs-quiz            already animates its own height
       .vs-heroimg         a single hero photo, revealing it looks like a fault
       .vs__glow           the atmospheric wash, must never blink
       .vs-lightbox        hidden overlay
  */
  var EXCLUDE = '.vs-carousel__card, .vs-tabs__panel, .vs-quiz, .vs-heroimg, .vs__glow, .vs-lightbox';

  /* Anything that CONTAINS a form is never hidden. A signup form is not
     decorative: mid-transition it is technically clickable while still
     partly invisible, and a form present but not yet visible is the one
     thing here not worth gambling on. Covers Kit embeds and Shopify forms. */
  var FORM_INSIDE = 'form, .formkit-form, [data-uid]';

  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, LINK: 1, TEMPLATE: 1, FORM: 1 };

  function start() {
    var nodes = [].slice.call(document.querySelectorAll(SELECTORS));
    if (!nodes.length) return;

    // Never hide anything even partly on screen at load, plus a 200px buffer
    // for tall viewports and slow first paints. An element that is visible
    // but invisible on arrival is the one failure worth designing against.
    var fold = window.innerHeight + 200;

    var toReveal = [];
    nodes.forEach(function (el) {
      if (SKIP_TAGS[el.tagName]) return;
      if (el.closest(EXCLUDE)) return;
      if (el.querySelector(FORM_INSIDE)) return;   // holds a form, leave visible
      if (el.classList.contains('vs-rv')) return;  // already tagged
      var r = el.getBoundingClientRect();
      if (r.top < fold) return;
      if (r.height === 0) return;

      el.classList.add('vs-rv');
      // Large blocks and the Resource Library get the gentler treatment.
      if (el.closest('.rl') || r.height > 520) el.classList.add('vs-rv--soft');
      toReveal.push(el);
    });
    if (!toReveal.length) return;

    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        obs.unobserve(e.target);
        setTimeout(function () { e.target.classList.add('is-done'); }, 1300);
      });
    }, { rootMargin: '0px 0px 8% 0px', threshold: 0.01 });

    toReveal.forEach(function (el) { io.observe(el); });

    // Safety net: anything still hidden but on screen a second after load
    // gets shown regardless. Covers resize, late fonts shifting layout, and
    // any element the observer never reports.
    setTimeout(function () {
      toReveal.forEach(function (el) {
        if (el.classList.contains('is-in')) return;
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-in');
      });
    }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
